import { render, staticRenderFns } from "./confirmUnion.vue?vue&type=template&id=f689cb4c&"
import script from "./confirmUnion.vue?vue&type=script&lang=js&"
export * from "./confirmUnion.vue?vue&type=script&lang=js&"
import style0 from "./confirmUnion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports